import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { ShipmentColumn } from '../../types/column-types'
import { onCellStandard, renderShipment } from '../../helpers/helpers'
import ShipmentDealCell from '../../components/cells/deal/deal'

export const dealColumn: ShipmentColumn = {
    dataIndex: 'deal',
    title: <RotatedTitle style={{ whiteSpace: 'nowrap' }}>Сделка</RotatedTitle>,
    width: 32,
    render: renderShipment(r => {
        return <ShipmentDealCell checked={r.deal} record={r} />
    }),
    onCell: onCellStandard,
}